import { getAuth, signOut } from 'firebase/auth';
import { addDoc, collection } from 'firebase/firestore';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from './firebase.js';

/**
 * Admin panel page
 * @returns
 */
export default function Admin() {
	// Auth
	const auth = getAuth();
	const navigate = useNavigate();
	const handleSignOut = () => {
		signOut(auth)
			.then(() => {
				// Sign-out successful.
				console.log('Sign out successful');
				navigate('/signin', {replace: true});
			})
			.catch(error => {
				// An error happened.
				console.error('Error signing out');
			});
	};

	// Blog Post Creation
	const [week, setWeek] = useState(null);
	const [topic, setTopic] = useState('');
	const [recordingLinks, setRecordingLinks] = useState('');
	const [slideLink, setSlideLink] = useState('');
	const [problemsetLink, setProblemsetLink] = useState('');
	const [date, setDate] = useState(new Date());
	const handlePost = async e => {
		e.preventDefault();
		// Transform GDrive share links into embed links
		const recordingLinksArray = recordingLinks.split(' ');
		const recordingEmbeds = recordingLinksArray.map(link =>
			link.replace(/\/view(\?.*)?$/, '/preview'),
		);
		const slideEmbed = slideLink.replace(/\/view(\?.*)?$/, '/preview');
		await addDoc(collection(db, 'blogs'), {
			week: parseInt(week),
			topic: topic,
			recordingLinks: recordingEmbeds,
			slideLink: slideEmbed,
			problemsetLink: problemsetLink || '',
			date: new Date(date),
		});
		setTopic('');
		setRecordingLinks('');
		setSlideLink('');
		setProblemsetLink('');
	};

	// /**
	//  * Converts all recordingLinks fields in the database into arrays containing themselves.
	//  * Written as a one-off after redesigning the field to take multiple values for multi-part recordings,
	//  * leaving here in case it is ever useful.
	//  */
	// const convertToList = async () => {
	// 	const querySnapshot = await getDocs(
	// 		// query(
	// 		collection(db, 'blogs'),
	// 		// 	where(documentId(), '==', 'ChDfnc0Op7DmAJKjco50'),
	// 		// ),
	// 	);
	// 	for (const docSnap of querySnapshot.docs) {
	// 		const recordingLinks = docSnap.data().recordingLinks;
	// 		if (recordingLinks === undefined || Array.isArray(recordingLinks)) continue;
	// 		const id = docSnap.id;
	// 		await updateDoc(docSnap.ref, {
	// 			recordingLinks: [recordingLinks],
	// 		});
	// 		console.log(`${id}: ${recordingLinks}`);

	// 	}
	// };
	// const renameField = async () => {
	// 	const querySnapshot = await getDocs(
	// 		// query(
	// 		collection(db, 'blogs'),
	// 		// 	where(documentId(), '==', 'ChDfnc0Op7DmAJKjco50'),
	// 		// ),
	// 	);
	// 	for (const docSnap of querySnapshot.docs) {
	// 		const recordingLink = docSnap.data().recordingLink;
	// 		if (!docSnap.data().recordingLink) continue;
	// 		const id = docSnap.id;
	// 		await updateDoc(docSnap.ref, {
	// 			// recordingLinks: recordingLink,
	// 			recordingLink: deleteField()
	// 		});
	// 		console.log(`${id}: ${recordingLink}`);

	// 	}
	// };

	return (
		<>
			<main>
				<p style={{fontFamily: "'Space Mono', monospace", fontWeight: 'bold'}}>
					Admin Panel <button onClick={handleSignOut}>SIGN OUT</button>
				</p>

				<section className="centercol">
					<form
						onSubmit={handlePost}
						style={{display: 'flex', flexDirection: 'column', width: '30%'}}
					>
						<h5>Create New Blog Post</h5>
						<label htmlFor="week">
							Week Number: {'(Leave blank for bonus week)'}
						</label>
						<input
							name="week"
							id="week"
							type="number"
							min="0"
							max="16"
							value={week}
							onChange={e => setWeek(e.target.value)}
							style={{width: '10%'}}
						/>

						<label htmlFor="topic">Topic:</label>
						<input
							name="topic"
							id="topic"
							type="text"
							required
							value={topic}
							onChange={e => setTopic(e.target.value)}
						/>

						<label htmlFor="recordingLinks">
							Recording GDrive link{`(s)`}: {`(Space-separated)`}
						</label>
						<input
							name="recordingLinks"
							id="recordingLinks"
							type="text"
							value={recordingLinks}
							onChange={e => setRecordingLinks(e.target.value)}
						/>

						<label htmlFor="slideLink">Slides PDF GDrive link:</label>
						<input
							name="slideLink"
							id="slideLink"
							type="text"
							value={slideLink}
							onChange={e => setSlideLink(e.target.value)}
						/>

						<label htmlFor="problemsetLink">Problemset link:</label>
						<input
							name="problemsetLink"
							id="problemsetLink"
							type="text"
							value={problemsetLink}
							onChange={e => setProblemsetLink(e.target.value)}
						/>

						<label htmlFor="date">Date: </label>
						<input
							name="date"
							id="date"
							type="datetime-local"
							value={date}
							onChange={e => setDate(e.target.value)}
							style={{width: '30%'}}
						/>

						<button
							type="submit"
							style={{
								fontFamily: "'Space Mono', monospace",
								background: 'var(--dark-bg)',
								color: 'white',
								marginTop: '20px',
								borderRadius: '5px',
								fontWeight: 'bold',
								paddingTop: '10px',
								paddingBottom: '10px',
							}}
						>
							Post
						</button>
					</form>
				</section>
			</main>
		</>
	);
}
